export default "__VITE_ASSET__$1oB2Qoj__"